<script>
	import { db } from '../../firebase';
	import { ideas, stackIndex, restart } from '../../store';
    
	// import Cardstack from '../../components/organisms/CardStack/CardStack.svelte';
	import CardSlider from '../../components/organisms/CardSlider/CardSlider.svelte';
	import Toast from '../../components/molecules/Toast/Toast.svelte'

	let loading = false;
	let startOver;

	// get public secured ideas, no real time updates. updates are handled by another onSnapshot listener in App.svelte (for now)
	const query = db.collection('ideas')
							.where('isPublic', '==', true)
							.where('isSecured', '==', true)
							.where('isHighlight', '==', false)
							.orderBy('timestamp', 'desc')

	// save the last query in the store so pagination remains functional after route change
	if(!$ideas.newest.query) { 
		$ideas.newest.query = query.limit(25);
		// get first batch if never fetched before
		loading = true;
		getBatch();
	}
	
	function getBatch () {
		$ideas.newest.query.get()
		.then((querySnapshot) => {
			const lastVisible = querySnapshot.docs[querySnapshot.docs.length-1];
			if(lastVisible) {
				$ideas.newest.query = $ideas.newest.query.startAfter(lastVisible);
				querySnapshot.forEach((doc) => {
					// it's better to use an object here, rather than an array.
					// this way, entries can be accessed by docId directly without searching through an array
					// then just loop over all keys in the CardStack.svelte
					// so instead of this:
					// $ideas.newest.entries = [...$ideas.newest.entries, {[doc.id]: doc.data()}];
					// do this:
					$ideas.newest.entries[doc.id] = doc.data();
				});
			}
		}).then(() => {
			loading = false
		})
		.catch((error) => {
			loading = false;
			console.log(error)
		})
	}

	function loadLatest () {
		$ideas.newest.entries = $ideas.newest.updates;
		$ideas.newest.updates = {};
		$restart = true;
		onLatestLoaded();
	}

	function onLatestLoaded () {
		startOver()
	}

	$: if($stackIndex.newest === Object.keys($ideas.newest.entries).length - 5) getBatch(); // start fetching new content when reaching the 5th last slide

</script>
<div>
	{#if Object.keys($ideas.newest.updates).length}
		<Toast on:loadLatest={loadLatest}/>
	{/if}
	<CardSlider bind:startOver {loading} page="feed" tab="newest" />
	<!-- <Cardstack page="feed" tab="newest" /> -->
</div>

<style>
	div {
		position: relative;
		display: flex;
		flex-direction: column;
		flex: 1;
	}
</style>